import React from 'react';
import classes from './contact.module.css';

const Contact = () => {
    return (
        <div className={ classes.contact }>
            <p>email: <a href="mailto:asayu&#64;ucl.nuee.nagoya-u.ac.jp">asayu&#64;ucl.nuee.nagoya-u.ac.jp</a></p>
        </div>
    );
}

export default Contact;